/*
 * @Email: xuyujian@new4g.com
 * @FilePath: /cbibank-web-corporbank/src/views/outward/components/api/index.js
 * @Date: 2021-12-20 10:31:16
 * @Author: zhangzhen
 * @LastEditTime: 2021-12-20 15:21:12
 */

import api from '@/utils/http/axios'
import { NO_PREFIX_URL } from '@/utils/http/base-url'

/**
  * 收款人名称删除
  * @param {string} recAccount            账号
  * @param {string} currentBusinessCode   默认值：10200500
  * @param {string} recBankType           本行：0 他行：1
  */
export function deleteCustomerPayee (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/deleteCustomerPayee.do`, params, config, 'URLEncoded')
}

/**
  * 收款人添加
  * @param {string} recAccount            收款方账号
  * @param {string} currentBusinessCode   默认值：10200500
  * @param {string} recBankType           本行：0 他行：1
  * @param {string} agencyBankAddress     收款方地址
  * @param {string} agentBankSwift        代理行seift
  * @param {string} agentRecBankName      代理行名称
  * @param {string} agentRecBankCountry   代理行国家
  * @param {string} agentRecBankAddress   代理行地址
  * @param {string} recBankAddress        银行地址
  * @param {string} recAccountName        收款方名称
  * @param {string} recCountry            银行国家
  * @param {string} bankSwift             银行swift
  * @param {string} recBankName           银行名称
  * @param {string} recBankCountry        收胯银行国家
  * @param {string} rem                   备注
  * @param {string} logRecordFlag         0不记录日志，1记录日志
  */
export function addCustomerPayee (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/addCustomerPayee.do`, params, config, 'URLEncoded')
}

/**
  * 收款人信息修改
  * @param {string} recAccount            账号
  * @param {string} currentBusinessCode   默认值：10200500
  * @param {string} recBankType           本行：0 他行：1
  */
export function modifyCustomerPayee (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/modifyCustomerPayee.do`, params, config, 'URLEncoded')
}

/**
  * 他行账户收款人详情
  * @param {string} searchAccount         账号
  * @param {string} currentBusinessCode   默认值：10200500
  * @param {string} recBankType           本行：0 他行：1
  * @param {string} sequenceNo
  */
export function customerPayeeInfo (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/customerPayeeInfo.do`, params, config, 'URLEncoded')
}
